import events from '../../constants/events';
import {ajaxUpdate} from '../../utilities/ajax';
import {dispatchEvent} from '../../utilities/customEvents';

import {Base} from './Base';

import animateScrollTo from 'animated-scroll-to';
import {initBehaviors} from '../';
import { getUserObject } from '../../utilities/relewise';

const selectors = {
  buttons: '.cart__buttons',
  item: '.cart__item',
  removeLink: '.cart__remove-link',
  updateQuantityDecrement: '.cart__quantity-decrement',
  updateQuantityIncrement: '.cart__quantity-increment',
  updateQuantityLink: '.cart__quantity-update',
  updateSizeSelect: '.cart__update-size',
  updateSizeLink: '.cart__update-size--link'
};

export class Cart extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.appendAdditionalMarkup();
    this.handleAjax();
    this.bindCartEmptyListener();
  }

  appendAdditionalMarkup() {
    const dataObject = {
      User: getUserObject()
    };

    if(dataObject) {
      const { form } = this.refs;
      const fragment = document.createElement('template');

      let anonymousUser = true;


      for(const [key, value] of Object.entries(dataObject['User'])) {
        if(key === 'TemporaryId' || key === 'AuthenticatedId') {
          anonymousUser = false;
          fragment.innerHTML += `<input type="hidden" name="attributes[${key}]" value="${value}"> `;
        }

        if(anonymousUser) {
          fragment.innerHTML = `<input type="hidden" name="attributes[User]" value="Anonymous">`;
        }
      }
      if(form) form.appendChild(fragment.content);
    }
  }

  handleAjax() {
    // Don't sent listeners for added-item-widget

    if(this.element.classList.contains('cart--can-remove')) {
      this.element.addEventListener('change', (e) => {
        // handler for changing product size in cart
        const select = e.target;
        const selectedOption = select.options[select.selectedIndex];
        const { currentVariantId, currentQuantity } = select.dataset;

        ajaxUpdate('/cart/update', {
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: {
              [currentVariantId]: 0,
              [selectedOption.value]: currentQuantity,
            }
          }),
          callback: () => {
            initBehaviors(this.element);
          },
          history: false,
          method: 'POST',
          selectors: ['.cart']
        });
      });

      this.element.addEventListener('click', (e) => {
        const link = e.target.closest(selectors.removeLink) || e.target.closest(selectors.updateQuantityLink) || e.target.closest(selectors.updateSizeLink);
        let item;

        if (link) {
          item = link.closest(selectors.item);
        }

        if (item && link) {
          e.preventDefault();

          let quantity = 0;

          if (e.target.closest(selectors.updateQuantityDecrement)) {
            quantity = -1;
          } else if (e.target.closest(selectors.updateQuantityIncrement)) {
            quantity = 1;
          } else if (e.target.closest(selectors.removeLink)) {
            quantity = 0;
          }

          ajaxUpdate(link.href, {
            callback: () => {
              dispatchEvent(window, events.CART_UPDATED, {
                numberOfItemsAdded: quantity
              });

              initBehaviors(this.element);
            },
            history: false,
            selectors: ['.cart', '.page-title']
          });
        }
      });
    }
  }


  bindCartEmptyListener() {
    this.cartEmptyHandler = this.handleCartEmpty.bind(this);
    window.addEventListener(events.CART_EMPTY, this.cartEmptyHandler);
  }

  handleCartEmpty() {
    animateScrollTo(0, {
      maxDuration: 500
    });
  }

  cleanup() {
    window.removeEventListener(events.CART_EMPTY, this.cartEmptyHandler);
  }
}
